/**
 * @generated SignedSource<<6536f3cc7cf4e2929d4f8ed5a38ee475>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardFieldIdsProvider_query$data = {
  readonly jira_categoryField: {
    readonly fieldId: string;
  } | null | undefined;
  readonly " $fragmentType": "BoardFieldIdsProvider_query";
};
export type BoardFieldIdsProvider_query$key = {
  readonly " $data"?: BoardFieldIdsProvider_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardFieldIdsProvider_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BoardFieldIdsProvider_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "jira_categoryField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "fieldId"
          },
          "action": "THROW",
          "path": "jira_categoryField.fieldId"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "bf40229ddd789b5fc14bbbffdfd29e07";

export default node;
